import Swiper from 'swiper';
import {initAlpine} from "./init";

// Before you start:
// 1. Change name and URL in package.json file
// 2. Build and release to npm
// 3. Replace the npm path in Webflow site custom footer code
// 4. Remove these comments


// -----> Write your functions here







// !!!!!!!!! Keep this Alpine init at the end !!!!!!!!!
window.Webflow ||= [];
window.Webflow.push(() => {
  initAlpine();
});
